import { render } from "./OtHours.vue?vue&type=template&id=72a9260e&scoped=true"
import script from "./OtHours.vue?vue&type=script&lang=js"
export * from "./OtHours.vue?vue&type=script&lang=js"

import "./OtHours.vue?vue&type=style&index=0&id=72a9260e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a9260e"]])

export default __exports__